import React, { useContext } from "react";
import { BsInstagram, BsLinkedin } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { ThemeContext } from "../ThemeContext";

const SocialMedia = () => {
  const { darkMode } = useContext(ThemeContext);
  return (
    <div className={darkMode === true ? "app__social-true" : "app__social"}>
      <div>
        <a href="https://www.facebook.com/profile.php?id=100012162124853">
          <FaFacebookF />
        </a>
      </div>
      <div>
        <a href="https://www.instagram.com/malik.fasih.5/">
          <BsInstagram />
        </a>
      </div>
      <div>
        <a href="https://www.linkedin.com/in/muhammad-fasih-z">
          <BsLinkedin />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
